module.exports = __webpack_public_path__ + "img/Sunny-Geevarghese.a97f643f.jpg";